export enum eDiscoveryStatusSearchType {
    All = "All",
    Pending = "Pending",
    Completed = "Completed"
}

export enum eDiscoveryRequestMode {
    Create,
    Search
}

export class eDiscoverySearchSpec {
    requestId?: string;
    organizationId?: string;
}

export class eDiscoveryDocumentSearchSpec extends eDiscoverySearchSpec {
    applicationNumbers: string[] = [];
    contactIds: string[] = [];
    workOrderIds: string[] = [];
    includeApplicationData: boolean = false;
    includeApplicationNotes: boolean = false;
    includeNotesForAllContacts: boolean = false;
    includeAllWorkOrders: boolean = false;
    includeOrganizationNotes: boolean = false;
    includeAllForOrganization: boolean = false;
}

export class eDiscoveryRequestSearchSpec extends eDiscoverySearchSpec {
    statusType?: eDiscoveryStatusSearchType;
    useNames: boolean;

    constructor(type: eDiscoveryStatusSearchType, organizationId: string) {
        super();
        this.statusType = type;
        this.requestId = "";
        this.organizationId = organizationId;
        this.useNames = false;
    }

}

export class eDiscoveryRequest {    
    applicationNumbers?: string;
    contacts?: string;
    dateCompleted?: Date;
    dateRequested?: Date;
    flowInstanceId?: string;
    includeApplicationData: boolean;
    includeApplicationNotes: boolean;
    includeNotesForAllContacts: boolean;
    includeOrganizationNotes: boolean;
    includeAllWorkOrders: boolean;
    notifyWhenComplete: boolean;
    organizationId: string;    
    requestId: string;
    requestedById?: string;
    requestedByName?: string;
    status: string;
    targetUrl?: string;
    workOrders?: string;
    isSinglePageApplication?: boolean;

    _displayText: string;
    get displayText(): string {
        if (this._displayText == null) {
            this._displayText = this.requestId;
        }
        return this._displayText;
    }

    set displayText(value: string) {
        this._displayText = value;
    }

    constructor(text: string) {
        this.requestId = "";
        this._displayText = text;
    }
}

export enum eDiscoveryRequestStatus {
    RequestPending = "Pending",
    InProcess = "In Process",
    RequestCompleted = "Completed"
}
